// import Repository from '@/libs/axios'
import OperationsRepository from '@/libs/customAxios/operationAxios'
import ListsRepository from '@/libs/customAxios/listsAxios'

const RiderResource = '/admin/rider'
const SettingResource = '/admin/settings'
export default {
  getAllRiderList() {
    return OperationsRepository.get(`${RiderResource}`)
  },
  getAllRiderDropDown() {
    return OperationsRepository.get(`${RiderResource}?noPagination`)
  },
  getDriverListForDropdown() {
    return OperationsRepository.get(`${RiderResource}/drivers`)
  },
  getAllRidersForDropdown() {
    return ListsRepository.get(`${RiderResource}/all-riders-dropdown`)
  },
  getRidersDropdownForAssignedWarehouse(warehouseId) {
    return ListsRepository.get(
      `${RiderResource}/warehouse-assigned-riders-dropdown?warehouse_id=${encodeURIComponent(warehouseId)}`,
    )
  },
  getriderParcelLimitSettings() {
    return OperationsRepository.get(`${SettingResource}/rider-parcel-limit`)
  },
  updateRiderParcelLimitSettings(payload) {
    return OperationsRepository.put(`${SettingResource}/rider-parcel-limit`, payload)
  },
}
